import { Helmet } from "react-helmet";
import CaseStudyHero from "../../components/case-studies/cases/reusables/CaseStudyHero";
import desktop from "../../assets/images/case-studies/cases/flexipainters/flexi-desktop.PNG";
import FlexiPaintersCaseStudyBody from "../../components/case-studies/cases/FlexipaintersCaseStudyBody";

export default function FlexiPainters() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/case-studies/flexipainters"
        />
        <meta
          name="description"
          content="Explore how NTUNA.COM transformed Flexi Painters to a world-class digital presence through a complete brand refresh, professional logo design, world-class website, professional social media resetup, SEO, and Google & Facebook Ads"
        />
        <meta
          property="og:description"
          content="Explore how NTUNA.COM transformed Flexi Painters to a world-class digital presence through a complete brand refresh, professional logo design, world-class website, professional social media resetup, SEO, and Google & Facebook Ads"
        />
        <meta
          property="og:title"
          content="Flexi Painters Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />

        <meta
          name="twitter:title"
          content="Flexi Painters Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          name="twitter:text:title"
          content="Flexi Painters Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          name="twitter:description"
          content="Explore how NTUNA.COM transformed Flexi Painters to a world-class digital presence through a complete brand refresh, professional logo design, world-class website, professional social media resetup, SEO, and Google & Facebook Ads"
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />
        <title>
          Flexi Painters Case Study | Website & Logo Design, Google & Facebook
          Ads Setup and Social Media Resetup | NTUNA.COM
        </title>
      </Helmet>
      <CaseStudyHero
        client="Flexi Painters"
        title="Flexi Painters"
        subtitle="How NTUNA.COM transformed Flexi Painters to a world-class digital presence through a complete brand refresh, professional logo design, world-class website, professional social media resetup, SEO, and Google & Facebook Ads — positioning the company for long-term growth and greater customer trust."
        caseImg={desktop}
      />
      <FlexiPaintersCaseStudyBody />
    </>
  );
}
